var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoMoment = function SvgLogoMoment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M19.272 44.728c-7.03-7.03-7.03-18.426 0-25.455 7.03-7.03 19.8-8.486 29.699-4.243l-4.245 4.244c7.03 7.03 7.03 18.426 0 25.456-7.03 7.029-19.797 8.483-29.697 4.24zM39.07 24.929c-3.905-3.905-10.237-3.905-14.142 0-3.905 3.906-3.905 10.237 0 14.143l-.002.001c3.906 3.905 10.237 3.905 14.142 0 3.905-3.906 3.905-10.237 0-14.142z",
    clipRule: "evenodd"
  })));
};
export default SvgLogoMoment;